import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  hyperlink: {
    textDecoration: 'None',
    display: 'flex',
    gap: theme.spacing(1),
    color: 'inherit',
  },
  form: {
    display: 'flex',
    width: theme.spacing(42.5),
  },
  modal: {
    width: theme.spacing(125),
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  apiWrapper: { display: 'flex', gap: theme.spacing(1) },
  container: {
    display: 'flex',
    gap: theme.spacing(5),
    '& .MuiAutocomplete-root': {
      width: '100%',
    },
  },
}))
